<p class="sg-color__danger" *ngFor="let error of errorCollection.errors">
    {{ error.title }} {{ error.description }}
</p>
